/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosRequestConfig } from 'axios';
import { axios } from '../axios.config';
import { stringify } from 'qs';

import { Media } from '../models/Media';

/* tslint:disable:no-unused-variable member-ordering max-line-length */

export class MediaApiResource {

    /**
     * Returns metadata about a piece of media
     * 
     * @param mediaId Media id
     */
    public getMedia(mediaId: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<Media> {
        const reqPath = '/v1/media/{mediaId}'
            .replace('{' + 'mediaId}', String(mediaId));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Download the source file originally uploaded for a piece of media
     * 
     * @param mediaId media id
     */
    public getOriginalFile(mediaId: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<{}> {
        const reqPath = '/v1/media/{mediaId}/file'
            .replace('{' + 'mediaId}', String(mediaId));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Upload a new piece of media
     * 
     * @param file 
     * @param watermarkMemberId member id to watermark URL of
     * @param version initial version to synchronously create
     * @param slug slug descriptor of file
     * @param minWidth minimum width required
     * @param minHeight minimum height required
     */
    public uploadMedia(file?: Partial<any>, query?: { watermarkMemberId?: string, version?: string, slug?: string, minWidth?: number, minHeight?: number }, axiosConfig?: AxiosRequestConfig): Promise<Media> {
        const reqPath = '/v1/media';
        let reqFormParams = {
            file: file
        };
        let reqConfig = {
            ...axiosConfig,
            method: 'POST',
            url: reqPath,
            params: query,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data: stringify(reqFormParams)

        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    public uploadExcel(data?: any, query?: { producttype?: string, orgid?: string, filename: string }, axiosConfig?: AxiosRequestConfig): Promise<Media> {
        const reqPath = '/v1/media/excel';
        // let reqFormParams = {
        //     file: file
        // };
        let reqConfig = {
            ...axiosConfig,
            method: 'POST',
            url: reqPath,
            headers: { 'Content-Type': 'multipart/form-data' },
            params: query,
            data: data

        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

}

export const MediaApi = new MediaApiResource();



// WEBPACK FOOTER //
// ./src/common/api/resources/MediaApi.ts